<template>

	<div class="m-backdrop show">
		<div class="m-body">
			<b-form
				class="form checkout-form"
				:class="{ disabled: processing }"
				@submit.prevent="handleSubmit"
			>
				<h2 class="m-title">
					{{ heading }}
				</h2>

				<AddressBlock
					:address="form.shipping_address"
					@completed="handleShippingAddressCompleted"
				/>

				<div class="m-button-container">
					<button type="submit" class="btn btn-secondary m-button">
						<span v-if="processing">Saving address...</span>
						<span v-else>Save address</span>
					</button>
				</div>
			</b-form>
		</div>
	</div>

</template>

<script>
	import api from '@js/api';
	import AddressBlock from './user-backend/Checkout/AddressBlock.vue';

	export default {
		components: {
			AddressBlock
		},

		props: {
			offers: {
				type: Array,
				required: true,
			},
			heading: {
				type: String,
				default: 'Order Confirmed! Tell Us Where To Ship Your Supplements!',
			},
		},

		data() {
			return {
				errors: [],
				validZipcode: null,
				processing: false,
				passesZipRegex: false,
				form: {
					shipping_address: {
						first_name: '',
						last_name: '',
						company_name: '',
						country: 'USA',
						address: '',
						address2: '',
						city: '',
						state: '',
						postal_code: '',
						phone_number: ''
					},
				},
			};
		},

		mounted() {
			document.body.classList.add('modal-open');
		},

		beforeDestroy() {
			document.body.classList.remove('modal-open');
		},

		methods: {
			async handleShippingAddressCompleted() {
				this.checkAddressCompleted(this.form.shipping_address);
			},

			async handleSubmit() {
				this.errors = [];
				this.processing = true;

				if (this.passesZipRegex) {
					try {
						const requestData = {offers: this.offers};

						requestData.shipping_address = {...this.form.shipping_address};
						const response = await api.acceptUpsell(requestData);
						window.location.href = response.meta.next_url;
					} catch (error) {
						const defaultMessage = 'Something went wrong, please contact customer support at support@sculptnation.com to place your order or try again.';
						this.errors = this.$ErrorHandler.parseResponseError(error, defaultMessage);
						this.processing = false;
						window.scrollTo({
							top: 0,
							behavior: 'smooth'
						});
					}
				} else {
					this.errors.push('Please enter a valid zipcode.');
					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
					this.processing = false;
				}
			},

			checkAddressCompleted(address) {
				const requiredProps = [
					'first_name',
					'last_name',
					'country',
					'address',
					/* 'address2', */
					'city',
					'state',
					'postal_code'
				];

				this.validateZipcode(address);

				return requiredProps.every(prop => address[prop] && address[prop].length > 0);
			},

			async validateZipcode(address) {
				const request = {
					state: address.state,
					city: address.city,
					country: address.country,
					postal_code: address.postal_code
				};
				const errorMessage = 'Please enter a valid zipcode.';
				let postalCodeRegex;
				switch (address.country) {
					case 'USA':
						postalCodeRegex = /^\d{5}(?:[-]?\d{4})?$/;
						break;
					case 'CAN':
						postalCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
						break;
					default:
						postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
				}

				this.errors.splice(this.errors.indexOf(errorMessage), 1);

				this.passesZipRegex = new RegExp(postalCodeRegex).test(address.postal_code);

				if (this.passesZipRegex && (address.country === 'USA' || address.country === 'CAN')) {
					try {
						this.validZipcode = (await api.validateAddress(request)).data;
						if (!this.validZipcode.is_valid) {
							this.errors.push(errorMessage);
							window.scrollTo({
								top: 0,
								behavior: 'smooth'
							});
						} else {
							this.errors.splice(this.errors.indexOf(errorMessage), 1);
						}
					} catch (error) {
						console.log(error);
					}
				} else if (!this.passesZipRegex) {
					this.errors.push(errorMessage);
					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				}
			},

		}
	}

</script>

<style lang="scss" scoped>
	.m-backdrop {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.7);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 100;
		text-align: left;
	}

	.m-body {
		background: #fff;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		overflow-y: auto;
		max-height: 85%;
		max-width: 800px;
		margin: 1rem;
		padding: 1.5rem;
	}

	.m-title {
		font-size: 1.5rem;
		font-weight: 600;
		margin-bottom: 1rem;
	}

	.m-button-container {
		border-top: 1px solid #e9ecef;
		padding-top: 1rem;
		text-align: right;
	}

	.m-button {
		background-color: #007bff;
		border-color: #007bff;

		&:hover {
			background-color: #0069d9;
			border-color: #0062cc;
		}
	}

	@media (min-width: 992px) {
		.m-body {
			padding: 2rem;
		}

		.m-title {
			font-size: 2rem;
			margin-bottom: 2rem;
		}
	}

</style>
